module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "720"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "pb-2"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Lookalikes - @" + _vm._s(_vm.handle))])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": 10,
      "no-data-text": 'Empty list'
    },
    scopedSlots: _vm._u([{
      key: "item.handle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-avatar', {
          staticStyle: {
            "margin": "10px 0"
          },
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": item.picture,
            "alt": "avatar"
          }
        })]), _vm._v(" "), _c('social-handle', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": _vm.platform === 'tiktok',
            "isInstagram": _vm.platform === 'instagram',
            "isYoutube": _vm.platform === 'youtube',
            "tiktokHandle": item.username,
            "instagramHandle": item.username,
            "youtubeHandle": item.custom_name
          }
        })], 1)])]
      }
    }, {
      key: "item.countryName",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [(item.countryName) ? _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                  " + _vm._s(item.countryName) + "\n                ")]) : _vm._e()])]
      }
    }, {
      key: "item.followers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                  " + _vm._s(_vm._f("thousandSeprator")(item.followers)) + "\n                ")])])]
      }
    }], null, true)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n        Close\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49924203"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/KeywordSearch/SimilarUsersModal.vue
// module id = 2109
// module chunks = 0